import AuthApi from '@apis/auth/AuthApi';
import useToast from '@hooks/ui/useToast';
import { ErrorResponse } from '@models/error';
import { useFlow } from '@router/stackflow';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useState } from 'react';
import { useCookies } from 'react-cookie';
import { useTranslation } from 'react-i18next';

function useWithdraw() {
    const { t } = useTranslation('accountTermination');
    const [checked, setChecked] = useState(false);
    const toast = useToast();
    const { pop } = useFlow();
    const [cookies, _, removeCookies] = useCookies(['accessToken', 'refreshToken']);
    const queryClient = useQueryClient();
    const { mutate } = useMutation({
        mutationFn: AuthApi.withdraw,
        onSuccess() {
            toast.info(t('toast.success'));
            queryClient.clear();
            removeCookies('accessToken', { path: '/' });
            removeCookies('refreshToken', { path: '/' });
            pop(3);
        },
        onError(e: AxiosError<ErrorResponse>) {
            toast.error(e.response?.data.message || t('toast.error'));
        },
    });
    const handleWithdraw = () => {
        const { refreshToken } = cookies;
        if (!refreshToken) {
            toast.error(t('toast.invalidAccess'));
            return;
        }
        mutate(refreshToken);
    };

    return {
        checked, setChecked, handleWithdraw,
    };
}

export default useWithdraw;
